import { useContext } from "react";
import { FlankSignUpContext } from "./FlankSignUpContextProvider";

const useFlankSignUpContext = () => useContext(FlankSignUpContext);

export default useFlankSignUpContext;
